import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("ZEADMARIAMADHAMWATANZEAD12345678"); // 32 bytes key
const iv = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16 bytes IV

export function encryptPassword(password) {
  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString(); // returns Base64 string
}
